import { useGetListingAlias } from './routes';
import type { CappsLandlordPropertyDetailsWebApiHandler_details_Options } from '@zg-rentals/ts-capps-client-react-query';
import { useCappsLandlordPropertyDetailsWebApiHandler_details } from '@zg-rentals/ts-capps-client-react-query';

/**
 * Gets property details using the listing alias from the URL
 */
export function useGetPropertyDetails(options?: Partial<CappsLandlordPropertyDetailsWebApiHandler_details_Options>) {
  const listingAlias = useGetListingAlias();
  return useCappsLandlordPropertyDetailsWebApiHandler_details(
    {
      listingAlias,
    },
    {
      ...options,
      enabled: !!listingAlias,
    },
  );
}
